import React from 'react'

import styled from "styled-components";

interface HighlightChangedProps {
  Hilite: boolean;
}

const HighlightChanged = styled.span<HighlightChangedProps>`
  display: inline-block;
  border-radius: 10px;
  padding: 3px;
  background-color: ${props => props.Hilite ? 'red' : 'white'};
  text-align: center;
  width: 40px;
  transition-property: background-color;
  transition-duration: 0.2s;
`;

interface VariablePresentationProps {
  Variable?: number | undefined;
  Hilite: boolean;
}

export const VariablePresentation = ({
  Variable,
  Hilite
} : VariablePresentationProps) => {
  return (
    <>
      <HighlightChanged Hilite={Hilite}>{Variable === null ? 'null' : Variable === undefined ? 'undef' : Variable}</HighlightChanged>
    </>
  )
}
